import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackClickEvent } from "../utils/analytics"; 
import ctaBg from "../assets/images/ctaimage.svg";
import { div } from "framer-motion/client";

export default function BottomCTA() {
  return (
    <div className="bg-black pt-16">
    <div className="relative w-full max-w-6xl mx-auto rounded-lg overflow-hidden shadow-2xl">
      {/* Internal Background Image */}
      <img
        src={ctaBg}
        alt="CTA Background"
        className="absolute inset-0 w-full h-full object-cover opacity-40 z-0"
      />

      {/* Overlay for darkening */}
      <div className="absolute inset-0 bg-black/20" />

      {/* Frosted Foreground Content */}
      <div className="relative z-10 px-6 sm:px-10 py-20 text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold tracking-wider font-heading mb-4">
          READY FOR TAKEOFF?
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-10 font-body">
          Photography. Ferrying. Day rates. Done with precision.
        </p>

        <Link
          to="/contact"
          onClick={() => trackClickEvent("CTA - Let’s Talk Click")}
          className="inline-flex items-center gap-2 px-8 py-4 h-16 rounded-full bg-white/10 hover:bg-strobe-red/20 text-white font-body font-medium backdrop-blur-md transition border border-white/30"
        >
          Let's Fly
          <ArrowRight className="w-5 h-5 stroke-[1.5]" />
        </Link>
      </div>
    </div>
    </div>
  );
}

